import { render, staticRenderFns } from "./VrstaSudionikaBase.vue?vue&type=template&id=261d4315&scoped=true&"
import script from "./VrstaSudionikaBase.vue?vue&type=script&lang=js&"
export * from "./VrstaSudionikaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261d4315",
  null
  
)

export default component.exports